import { Grid } from '@mui/material';

/**
 * Envuelve un campo de alcance en un `Grid item` cuando el filtro de la pantalla usa `Grid`;
 * si no, lo devuelve tal cual para filtros flex.
 * @param {Object} props
 * @param {Object} [props.gridItemProps] Props del `Grid item` de este campo.
 * @param {JSX.Element} props.children Campo a mostrar.
 * @returns {JSX.Element}
 */
const MaterialScopeFieldItem = ({ gridItemProps, children }) =>
  gridItemProps ? (
    <Grid item {...gridItemProps}>
      {children}
    </Grid>
  ) : (
    children
  );

export default MaterialScopeFieldItem;
